var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComicBooks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Kawaii-Manga-Screentone-Effect-Action-Text-Bubble--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Kawaii Manga Screentone Effect Action Text Bubble Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.37 11a2.71 2.71 0 0 1 -1.79 -2.53 2.78 2.78 0 0 1 0.19 -1 1 1 0 0 0 -0.26 -1.1 1 1 0 0 0 -1.12 -0.16 2.69 2.69 0 0 1 -3.84 -1.88 1 1 0 0 0 -0.85 -0.81 1 1 0 0 0 -1 0.55 2.66 2.66 0 0 1 -4.81 0 1 1 0 0 0 -1.22 -0.5A1 1 0 0 0 8 4.75a2.73 2.73 0 0 1 0 0.5 2.68 2.68 0 0 1 -4.35 2.09 1 1 0 0 0 -1.51 1.25 2.64 2.64 0 0 1 0.34 1.28A2.71 2.71 0 0 1 0.69 12.4a1 1 0 0 0 0 1.88 2.69 2.69 0 0 1 1.79 2.52 2.61 2.61 0 0 1 -0.1 0.69 1 1 0 0 0 0.44 1.11A1 1 0 0 0 4 18.5a2.62 2.62 0 0 1 1.78 -0.7 2.68 2.68 0 0 1 2.67 2.47 1 1 0 0 0 0.8 0.9l0.2 0a1 1 0 0 0 0.89 -0.54 2.66 2.66 0 0 1 4.74 0 1 1 0 0 0 1.14 0.49 1 1 0 0 0 0.74 -1A0.62 0.62 0 0 0 17 20a2.7 2.7 0 0 1 2.7 -2.66 2.87 2.87 0 0 1 0.81 0.14 1 1 0 0 0 1.25 -1.25 2.93 2.93 0 0 1 -0.14 -0.81 2.71 2.71 0 0 1 1.79 -2.53 1 1 0 0 0 0 -1.88Zm-3.79 4.33A4.71 4.71 0 0 0 15.41 18a4.83 4.83 0 0 0 -5.55 0.13 4.63 4.63 0 0 0 -4.07 -2.33 5 5 0 0 0 -1.38 0.2 4.71 4.71 0 0 0 -1.47 -2.67 4.7 4.7 0 0 0 1.54 -3.46 4.8 4.8 0 0 0 0.85 0.08 4.72 4.72 0 0 0 4.4 -3.06 4.65 4.65 0 0 0 5.58 -0.39 4.74 4.74 0 0 0 4.27 2 4.7 4.7 0 0 0 1.55 3.5 4.68 4.68 0 0 0 -1.55 3.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72 5.25a1 1 0 0 0 0.81 0.42 1 1 0 0 0 0.58 -0.19 1 1 0 0 0 0.24 -1.4L1.85 0.58A1 1 0 0 0 0.45 0.35a1 1 0 0 0 -0.23 1.4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39 2.61a1 1 0 0 0 0.89 0.56 1 1 0 0 0 0.45 -0.11 1 1 0 0 0 0.45 -1.34l-0.5 -1A1 1 0 0 0 6.33 0.27a1 1 0 0 0 -0.44 1.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28 4.17a1 1 0 0 0 1 -1V1a1 1 0 0 0 -2 0v2.17a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3.61a0.85 0.85 0 0 0 0.31 0.06 1 1 0 0 0 0.92 -0.67l0.5 -1.5a1 1 0 0 0 -1.9 -0.63l-0.5 1.5A1 1 0 0 0 18 3.61Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.57 19 -0.31 0.31a1 1 0 0 0 0 1.42A1 1 0 0 0 1 21a1 1 0 0 0 0.71 -0.29l0.29 -0.34A1 1 0 0 0 2 19a1 1 0 0 0 -1.43 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 19.74a1 1 0 0 0 -1.3 0.55l-0.93 2.34a1 1 0 0 0 0.56 1.3 0.94 0.94 0 0 0 0.37 0.07 1 1 0 0 0 0.93 -0.63L6.46 21a1 1 0 0 0 -0.56 -1.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.72 20.92a1 1 0 0 0 -1 1V23a1 1 0 0 0 2 0v-1.08a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.86 19.6a1 1 0 0 0 -1.66 1.13l1.92 2.83A1 1 0 0 0 22 24a1 1 0 0 0 0.56 -0.17 1 1 0 0 0 0.27 -1.39Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 4.75a1 1 0 0 0 0.55 0.17 1 1 0 0 0 0.83 -0.45l0.94 -1.4a1 1 0 0 0 -0.28 -1.39 1 1 0 0 0 -1.38 0.32l-0.94 1.4a1 1 0 0 0 0.28 1.35Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComicBooks);
export default ForwardRef;